export class FrontendNewVersionAvailableEvent {}

export class LoadScriptFailedEvent {}
